
export const usageTypeCodes = {
  GENERIC: 'GENERIC',
  PRODUCT_SPECIFIC: 'PRODUCT_SPECIFIC',
  CUSTOMER_SPECIFIC: 'CUSTOMER_SPECIFIC',
}
